import { createContext } from 'react';

import type { ABTesting, Lucid, I18n } from '../../types/types';

export interface LayoutContextProps {
  abTesting?: {
    updateTest: ABTesting.DispatchTest;
  };
  language: {
    i18nKey: I18n.AvailableLanguagesI18nKey;
    shortLangPrefix: I18n.AvailableLanguages;
    urlLangPrefix: I18n.AvailableLanguagesURLPrefix;
    languageKey: I18n.AvailableLanguagesKey;
  };
  pageType: string;
  product?: Lucid.Product.Sites;
}

const layoutContext: LayoutContextProps = {
  abTesting: {
    updateTest: () => undefined,
  },
  language: {
    shortLangPrefix: 'en',
    urlLangPrefix: '',
    i18nKey: 'en',
    languageKey: 'en',
  },
  pageType: '',
  product: undefined,
};

export const layoutContextDefaults = layoutContext;

export default createContext(layoutContext);
